// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2778":"8ce15ade","4252":"8ce15ade","5195":"2a0701e7","8627":"d8db74e6","9507":"1b5935a3"}[chunkId] + ".chunk.css";
};